import React from 'react';
import { motion } from 'framer-motion';
import { FiPhone, FiMessageCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function LeadForm() {
  return (
    <section id="get-offer" className="py-24 bg-brand-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-white rounded-3xl shadow-xl overflow-hidden"
        >
          <div className="grid md:grid-cols-5 h-full">
            {/* Info Side */}
            <div className="md:col-span-2 bg-brand-600 p-8 md:p-10 text-white flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-serif font-bold mb-4">Fast & Simple</h3>
                <p className="text-brand-100 mb-8">
                  We believe in real conversations over complicated paperwork. Reach out to get your free, no-obligation cash offer.
                </p>
                <ul className="space-y-4">
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-brand-500 flex items-center justify-center text-sm font-bold shadow-sm">
                      <SafeIcon icon={FiPhone} />
                    </div>
                    <span className="font-medium">Call or Text Stu</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-brand-500 flex items-center justify-center text-sm font-bold shadow-sm">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path></svg>
                    </div>
                    <span className="font-medium">We review the market</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-brand-500 flex items-center justify-center text-sm font-bold shadow-sm">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                    </div>
                    <span className="font-medium">Get your cash offer</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* CTA Side */}
            <div className="md:col-span-3 p-8 md:p-12 flex flex-col justify-center items-center text-center">
              <div className="w-20 h-20 bg-brand-50 rounded-full flex items-center justify-center mb-6">
                <SafeIcon icon={FiMessageCircle} className="text-4xl text-brand-500" />
              </div>
              <h4 className="text-3xl font-serif font-bold text-stone-900 mb-4">Ready for Your Offer?</h4>
              <p className="text-stone-600 mb-8 text-lg">
                Skip the waiting game. Call or text Stu directly to discuss your property and start the process today.
              </p>
              
              <a 
                href="tel:2512431403"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-stone-900 hover:bg-stone-800 text-white font-bold py-5 px-8 rounded-xl transition-colors text-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
              >
                <SafeIcon icon={FiPhone} className="text-brand-400" />
                (251) 243-1403
              </a>
              
              <p className="text-sm font-medium text-stone-500 mt-6 uppercase tracking-wider">
                Call or Text Anytime
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}